import styled from '@emotion/styled';
import ClickOutside from '~/components/ClickOutside';
import Text from '~/components/Text';

const StatusGuidePopup = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 16px;
  width: 400px;
  z-index: 1000;

  .status-header {
    border-bottom: 1px solid var(--border1);
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
`;

const StatusRow = styled.div`
  display: flex;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  .status-label {
    min-width: 150px;
  }
`;

const statusGuideData = [
  {
    label: 'Draft',
    description: 'Invoice is being prepared, not sent yet.',
  },
  {
    label: 'Sent',
    description: 'Sent to customer, awaiting payment.',
  },
  {
    label: 'Overdue',
    description: 'Due date passed, still unpaid or partially paid.',
  },
  {
    label: 'On Time',
    description: 'Invoice still within due period, not yet overdue.',
  },
  {
    label: 'Outstanding',
    description: 'Due date not reached yet, still unpaid.',
  },
  {
    label: 'Paid',
    description: 'Fully paid.',
  },
  {
    label: 'Archived',
    description: 'Closed and stored for just record-keeping.',
  },
];

interface StatusGuidePopupProps {
  onClose: () => void;
}

const StatusGuidePopupComponent = ({ onClose }: StatusGuidePopupProps) => {
  return (
    <ClickOutside onClose={onClose}>
      <StatusGuidePopup>
        <Text size="xs" className="bold status-header">
          Invoice Status Guide
        </Text>
        {statusGuideData.map(status => (
          <StatusRow key={status.label}>
            <Text size="xs" className="bold status-label">
              {status.label}
            </Text>
            <Text size="xs">{status.description}</Text>
          </StatusRow>
        ))}
      </StatusGuidePopup>
    </ClickOutside>
  );
};

export default StatusGuidePopupComponent;
